// extracted by mini-css-extract-plugin
module.exports = {"faqWrapper":"Faq_faqWrapper__kgu2V","faq":"Faq_faq__gzHGx","title":"Faq_title__XxwbG","desc":"Faq_desc__ux6em","btn":"Faq_btn__FJTQo"};